export function addAirDatapicker($inputs) {
	$inputs.each(function () {
		let $size_span = $(this).prev('.size-span');
		let dp = new AirDatepicker(this, {
			autoClose: true,
			maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
			dateFormat: 'MM/dd/yyyy',
			locale: {
				days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
				daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
				daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
				months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
				monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
				today: 'Today',
				clear: 'Clear',
				dateFormat: 'MM/dd/yyyy',
				timeFormat: 'hh:mm aa',
				firstDay: 0,
			},
			isMobile: false,
			onSelect({date, formattedDate}) {
				$size_span.text(formattedDate);
			},
		});

		let value = $(this).val();
		
		if (value) {
			dp.selectDate(value);
			dp.setViewDate(value);
		}
	});
}
